import React from 'react'

const RtLink = ({ children, value: { href } }) => (
	<a className="link text-orange" href={href}>{children}</a>
)

export default RtLink
